import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store";
import Mixin from '@utils/mixin'
createApp(App).use(store).mixin(Mixin).use(router).mount('#app')